import { FC, useCallback, useRef } from 'react'
import { NodeProps } from '@xyflow/react'
import styled, { css } from 'styled-components'
import {
  Text,
  GreyGrey70,
  Primary12Regular,
  Primary13Regular,
  Primary13SemiBold,
  ShadowM,
  YellowYellow10,
  YellowYellow80,
  Flex
} from '@sequencehq/core-components'
import { useNode } from 'Automations/nodeDefinitions/hooks'
import { Config } from '../note'

export const NoteEditorNode: FC<NodeProps> = ({ id, selected }) => {
  const { nodeData, setNodeData } = useNode<Config>({ nodeId: id })

  const textareaRef = useRef<HTMLTextAreaElement>(null)

  const handleInput = useCallback(
    (content: string) => {
      if (!textareaRef.current) return
      setNodeData('content', content)

      textareaRef.current.style.height = 'auto'
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`
    },
    [setNodeData]
  )

  if (!nodeData) return null

  return (
    <Flex
      data-testid="automations.editor.note.container"
      flexDir="column"
      borderColor={selected ? YellowYellow80 : `rgba(146, 64, 14, 0.16)`}
      borderWidth="1px"
      borderStyle="solid"
      width="222px"
      minHeight="222px"
      padding="12px"
      backgroundColor={YellowYellow10}
      gap="8px"
      borderRadius="12px"
      boxShadow={selected ? ShadowM : undefined}
    >
      <Text {...Primary13SemiBold} color={YellowYellow80}>
        Note
      </Text>

      <Flex flexDir="column" gap="8px" justifyContent="space-between" flex="1">
        <NoteTextarea
          data-testid="automations.editor.note.textarea"
          ref={textareaRef}
          onChange={e => handleInput(e.target.value)}
          placeholder="Add text"
          value={nodeData.content}
        />

        <Text
          data-testid="automations.editor.note.createdByEmail"
          {...Primary12Regular}
          color={GreyGrey70}
        >
          {nodeData.createdByEmail}
        </Text>
      </Flex>
    </Flex>
  )
}

const NoteTextarea = styled.textarea`
  width: 100%;
  padding: 0;
  border: 0;
  border-radius: 0;
  background: transparent;
  color: ${YellowYellow80};
  ${css(Primary13Regular)}
  resize: none;
  overflow: hidden;

  &:focus-visible {
    outline: none;
    box-shadow: none;
  }

  &::placeholder {
    color: rgba(146, 64, 14, 0.5);
  }
`
